import { Skeleton } from '@linktivity/link-ui';
import productStyles from '../product.module.css';
import styles from './skeleton.module.css';

export const ImagesSkeleton = () => (
  <div className={styles.imagesSkeleton}>
    <Skeleton className={styles.imagesContent} />
  </div>
);

export const HeaderSkeleton = () => (
  <div className={styles.header}>
    <Skeleton className={styles.title} />
    <div className={styles.tags}>
      <Skeleton className={styles.tag} />
      <Skeleton className={styles.tag} />
    </div>
  </div>
);

export const DescriptionSkeleton = () => (
  <div className={styles.description}>
    <Skeleton className={styles.descriptionLine} />
    <Skeleton className={styles.descriptionLineShort} />
  </div>
);

export const PlanCardSkeleton = () => (
  <div className={styles.planCard}>
    <div className={styles.planCardHeader}>
      <div className={styles.planCardInfo}>
        <Skeleton className={styles.planTag} />
        <Skeleton className={styles.planTitle} />
        <Skeleton className={styles.planSubtitle} />
      </div>
      <Skeleton className={styles.planPrice} />
    </div>
  </div>
);

export const PlansSkeleton = () => (
  <div className={styles.plans}>
    <Skeleton className={styles.plansTitle} />
    <div className={styles.planTags}>
      <Skeleton className={styles.planTagItem} />
      <Skeleton className={styles.planTagItem} />
      <Skeleton className={styles.planTagItem} />
    </div>
    <PlanCardSkeleton />
    <PlanCardSkeleton />
  </div>
);

export const CalendarSkeleton = () => (
  <div className={styles.calendar}>
    <div className={styles.calendarHeader}>
      <Skeleton className={styles.calendarNav} />
      <Skeleton className={styles.calendarMonth} />
      <Skeleton className={styles.calendarNav} />
    </div>
    <div className={styles.calendarWeekdays}>
      {Array.from({ length: 7 }).map((_, i) => (
        <Skeleton key={i} className={styles.calendarWeekday} />
      ))}
    </div>
    <div className={styles.calendarDays}>
      {Array.from({ length: 35 }).map((_, i) => (
        <Skeleton key={i} className={styles.calendarDay} />
      ))}
    </div>
  </div>
);

export const UnitSkeleton = () => (
  <div className={styles.units}>
    {Array.from({ length: 3 }).map((_, i) => (
      <div key={i} className={styles.unitRow}>
        <div className={styles.unitInfo}>
          <Skeleton className={styles.unitName} />
          <Skeleton className={styles.unitPrice} />
        </div>
        <Skeleton className={styles.unitCounter} />
      </div>
    ))}
  </div>
);

export const CancelPolicySkeleton = () => (
  <div className={styles.cancelPolicy}>
    <Skeleton className={styles.cancelPolicyTitle} />
    <div className={styles.cancelPolicyContent}>
      <Skeleton className={styles.cancelPolicyLine1} />
      <Skeleton className={styles.cancelPolicyLine2} />
      <Skeleton className={styles.cancelPolicyLine3} />
    </div>
  </div>
);

export const PaymentSkeleton = () => (
  <div className={styles.payment}>
    <Skeleton className={styles.paymentTitle} />
    <Skeleton className={styles.paymentDateTime} />
    <div className={styles.paymentUnits}>
      <Skeleton className={styles.paymentUnitLine} />
      <Skeleton className={styles.paymentUnitLine} />
    </div>
    <Skeleton className={styles.paymentTotal} />
    <Skeleton className={styles.paymentButton} />
  </div>
);

export const OptionSkeleton = () => (
  <div className={styles.options}>
    {Array.from({ length: 3 }).map((_, i) => (
      <div key={i} className={styles.optionCard}>
        <Skeleton className={styles.optionImage} />
        <div className={styles.optionInfo}>
          <Skeleton className={styles.optionTitle} />
          <Skeleton className={styles.optionDescription} />
          <Skeleton className={styles.optionPrice} />
        </div>
      </div>
    ))}
  </div>
);

export default function ProductSkeleton() {
  return (
    <div className={productStyles.product}>
      <ImagesSkeleton />
      <div className={styles.wrapper}>
        <div className={styles.left}>
          <HeaderSkeleton />
          <DescriptionSkeleton />
          <PlansSkeleton />
          <CancelPolicySkeleton />
        </div>
        <div className={styles.right}>
          <PaymentSkeleton />
        </div>
      </div>
    </div>
  );
}
